import { render, staticRenderFns } from "./organization-amount-change-record.vue?vue&type=template&id=ad810ff0&scoped=true&"
import script from "./organization-amount-change-record.vue?vue&type=script&lang=js&"
export * from "./organization-amount-change-record.vue?vue&type=script&lang=js&"
import style0 from "./organization-amount-change-record.vue?vue&type=style&index=0&id=ad810ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad810ff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad810ff0')) {
      api.createRecord('ad810ff0', component.options)
    } else {
      api.reload('ad810ff0', component.options)
    }
    module.hot.accept("./organization-amount-change-record.vue?vue&type=template&id=ad810ff0&scoped=true&", function () {
      api.rerender('ad810ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-finance-management/organization-amount-change-record.vue"
export default component.exports